<template>
<div>
    <div class="main-body desktop">
        <div class="circles">
            <div class="big-circle"></div>
            <div class="medium-circle"></div>
            <div class="small-circle"></div>
        </div>
        <div class="site-header">
            <router-link class="brand" to="/">
                <img class="logo-img" src="../assets/images/cs-logo-light.svg" alt="" />
            </router-link>
        </div>
        <b-row>
            <b-col cols="6"></b-col>
            <b-col class="mt-5 form-box">
                <p>Complete Payment</p>
                <p>Loading...</p>
            </b-col>
        </b-row>
        <div class="foot-text">
            <p>Welcome to Culture Square</p>
        </div>

    </div>
    <div class="mobile">
        <AbstractHeader />
        <div class="form-box text-center">
            <p>Complete Payment</p>
            <p>Loading...</p>
        </div>
    </div>
</div>
</template>

<script>
import AbstractHeader from "@/components/AbstractHeader.vue";

import axios from "axios";
import {
    getBaseUrl
} from "../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'stripe-refresh',
    data: () => ({
        loading: false
    }),
    components: {
        AbstractHeader
    },
    computed: {
        isLoggedIn: function () {
            return this.$store.getters.userAuthenticated;
        },
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
    },
    mounted() {
        this.refresh();
    },
    methods: {
        async refresh() {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/stripe`,
                    method: "GET",
                })
                const stripe_url = resp.data.stripe_onboard_url
                window.location.href = stripe_url
            } catch (error) {
                this.loading = false;
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.main-body {
    height: 100vh;
    background-image: url('../assets/images/abstract.svg');
    background-repeat: no-repeat;
}

.site-header {
    padding: 30px 50px;
}

.form-control {
    height: calc(1.5em + 0.75rem + 15px) !important;
}

.logo-img {
    position: fixed;
    width: 8%
}

.circles {
    position: absolute
}

.big-circle {
    position: relative;
    left: 191%;
    top: -58px;
    height: 190px;
    width: 190px;
    border-radius: 50%;
    background: #F7B131;
}

.medium-circle {
    position: relative;
    left: 295%;
    top: -90px;
    height: 100px;
    width: 100px;
    border-radius: 50%;
    background: #F7B131;
}

.small-circle {
    position: relative;
    left: 300%;
    top: -50px;
    height: 62px;
    width: 62px;
    border-radius: 50%;
    background: #F7B131;
}

.form-container {
    background: none;
    box-shadow: none;
    padding: 30px 15px 15px 0px !important;
}

a {
    color: #F7B131;
}

.form-box {
    padding: 40px 75px 50px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 40px 20px 20px 20px;
    }
}

.form-box p:first-child {
    font-size: 28px;
    border-bottom: 1px solid #E0E0E0;
}

.foot-text {
    color: #fff;
    position: fixed;
    bottom: 0;
    padding-bottom: 1rem
}

.foot-text p {
    padding-left: 2.5rem;
    font-size: 14px
}

.foot-text ul {
    display: flex
}

.foot-text ul>li {
    margin: 0 10px;
}

.button-contain {
    margin-top: 80px;

}

.button-contain button {
    width: 100%
}

.svg-inline--fa {
    height: 0.7em !important
}

@media screen and (min-width: 1400px) {
    .big-circle {
        position: relative;
        left: 191%;
        top: -58px;
        height: 211px;
        width: 211px;
        border-radius: 50%;
        background: #F7B131;
    }

    .medium-circle {
        position: relative;
        left: 285%;
        top: -90px;
        height: 129px;
        width: 129px;
        border-radius: 50%;
        background: #F7B131;
    }

    .small-circle {
        position: relative;
        left: 280%;
        top: -50px;
        height: 62px;
        width: 62px;
        border-radius: 50%;
        background: #F7B131;
    }
}
</style>
